<template>
  <div>
    <div class="main-content" style="margin-top: -50px">
      <div class="row" style="padding: 15px">
        <div class="col-md-12 title-form">Dados da Empresa</div>
        <!-- <div class="col-md-6">
          <label><span class="required">*</span> Razão Social</label>
          <input type="text" class="form-control" v-model="cad.company_name" />
        </div>
        <div class="col-md-6">
          <label><span class="required">*</span> Nome Fantasia</label>
          <input
            type="text"
            class="form-control"
            v-model="cad.company_name_fantasy"
          />
        </div> -->
        <div class="col-md-2 mt-2">
          <label><span class="required">*</span> CNPJ</label>
          <input
            type="text"
            class="form-control"
            v-model="cad.cnpj"
            v-mask="'##.###.###/####-##'"
            @keyup="buscarCnpj()"
          />
        </div>
        <!-- <div class="col-md-4 mt-2">
          <label><span class="required">*</span> Telefone / Celular</label>
          <input
            type="text"
            class="form-control"
            v-model="cad.telephone"
            v-mask="'(##) ####-#####'"
          />
        </div> -->
        <div class="col-md-4 mt-2">
          <label><span class="required">*</span> E-mail</label>
          <input type="text" class="form-control" v-model="cad.company_email" />
        </div>
        <!-- <div class="col-md-2 mt-2">
          <label><span class="required">*</span> CEP</label>
          <input
            type="text"
            class="form-control"
            v-mask="'#####-###'"
            v-model="cad.cep"
            @keyup="buscar()"
          />
        </div> -->
        <!-- <div class="col-md-8 mt-2">
          <label><span class="required">*</span> Logradouro</label>
          <input type="text" class="form-control" v-model="cad.street" />
        </div> -->

        <!-- <div class="col-md-2 mt-2">
          <label><span class="required">*</span> Número</label>
          <input
            id="inputNumero"
            type="text"
            class="form-control"
            v-model="cad.number"
          />
        </div> -->
        <!-- <div class="col-md-3 mt-2">
          <label><span class="required">*</span> Bairro</label>
          <input type="text" class="form-control" v-model="cad.neighborhood" />
        </div> -->
        <!-- <div class="col-md-3 mt-2">
          <label>Complemento</label>
          <input type="text" class="form-control" v-model="cad.complement" />
        </div> -->
        <!-- <div class="col-md-3 mt-2">
          <label><span class="required">*</span> Cidade</label>
          <input type="text" class="form-control" v-model="cad.city" />
        </div> -->
        <!-- <div class="col-md-3 mt-2">
          <label><span class="required">*</span> Estado</label>
          <input type="text" class="form-control" v-model="cad.state" />
        </div> -->
      </div>
      <div class="row" style="padding: 15px">
        <div class="col-md-12 title-form">
          Dados da Usuário (Estes dados serão utilizados para acessar a
          plataforma)
        </div>
        <div class="col-md-6">
          <label><span class="required">*</span> Nome Completo</label>
          <input type="text" v-model="cad.user_name" class="form-control" />
        </div>
        <div class="col-md-6">
          <label><span class="required">*</span> E-mail</label>
          <input
            type="text"
            autocomplete="new-password"
            v-model="cad.user_email"
            class="form-control"
          />
        </div>
        <div class="col-md-6 mt-2">
          <label><span class="required">*</span> Senha</label>
          <input
            type="password"
            id="password"
            autocomplete="new-password"
            v-model="cad.password"
            class="form-control"
          />
        </div>
        <div class="col-md-6 mt-2">
          <label><span class="required">*</span> Confirme a Senha</label>
          <input
            type="password"
            autocomplete="new-password"
            v-model="cad.password_confirm"
            class="form-control"
          />
        </div>
        <div class="col-md-12 mt-5">
          <buttton class="btn btn-filters" @click="save">
            Criar Cadastro no Invitee
          </buttton>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      new_path: "/",
      cad: {
        company_name: "",
        company_name_fantasy: "",
        telephone: "",
        company_email: "",
        cep: "",
        state: "",
        neighborhood: "",
        city: "",
        street: "",
        complement: "",
        user_name: "",
        user_email: "",
        password: "",
        password_confirm: "",
      },
      endereco: {},
      cnpj: {},
    };
  },
  computed: {},
  methods: {
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    save() {
      const self = this;
      const api = this.$store.state.apiInvitee + "trial/install";

      axios
        .post(api, self.cad)
        .then(() => {
          self.$message(
            "Sucesso",
            "Cadastrado com sucesso, verifique seu e-mail",
            "success"
          );
          window.location.href = "https://app.invitee.com.br";
          self.cad = {};
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    buscarCnpj: function () {
      var self = this;

      var str = self.cad.cnpj;
      str = str.replace(".", "");
      str = str.replace(".", "");
      str = str.replace("/", "");
      str = str.replace("-", "");
      if (str.length > 13) {
        $.getJSON("https://receitaws.com.br/v1/cnpj/" + str, function (cnpj) {
          console.log(cnpj);
          if (cnpj.erro) {
            self.cnpj = {};
            return;
          }
          self.cnpj = cnpj;
          self.cad.company_name = self.cnpj.nome;
          self.cad.company_name_fantasy = self.cnpj.nome;
          self.cad.telephone = self.cnpj.telefone;
          self.cad.company_email = self.cnpj.email;
          self.cad.street = self.cnpj.logradouro;
          self.cad.neighborhood = self.cnpj.bairro;
          self.cad.complement = self.cnpj.complemento;
          self.cad.city = self.cnpj.municipio;
          self.cad.state = self.cnpj.uf;
          self.cad.cep = self.cnpj.cep;
        });
      }
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.cad.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.cad.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.cad.street = self.endereco.logradouro;
            self.cad.neighborhood = self.endereco.bairro;
            self.cad.state = self.endereco.uf;
            self.cad.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
  },
  components: {},
  props: {},
  mounted: function () {
    const self = this;
  },
};
</script>
<style scoped>
.title-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}
.alert-purple {
  border-color: #4a05a0;
  background-color: #4a05a0;
  color: #ffffff;
}

.form-control {
  border: none;
  border-bottom: 2px solid #4a05a0 !important;
  border-radius: 0;
  color: #666 !important;
  font-size: 14px;
  padding: 0;
  height: 30px;
}
.btn-filters {
  margin-top: -15px;
  margin-bottom: 25px;
  border: 2px #4a05a0 solid !important;
  cursor: pointer;
  background-color: #fff;
  color: #666 !important;
  font-weight: bold;
}

.btn-filters:hover {
  border: 2px #4a05a0 solid !important;
  background-color: #4a05a0 !important;
  cursor: pointer;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Trial/Invitee.vue